require('dotenv').config()

const Auth0Config = {
    auth0Domain: process.env.AUTH0_DOMAIN ?? 'dev-x4mh4vgb.eu.auth0.com',
    auth0Ident: process.env.AUTH0_API_IDENTIFIER ?? '',
    auth0ClientId: process.env.AUTH0_CLIENTID ?? '3uLHvAZznkcVfPE4AGw6XQ702jjb8SlG'
}

export default Auth0Config;